import Splide from "@splidejs/splide";

const SPLIDE_SELECTOR = ".home-line-up__splide";

function mountLineUpSplide(root: HTMLElement) {
  new Splide(root, {
    perPage: 3,
    perMove: 3,
    flickMaxPages: 1,
    flickPower: 150,
    dragMinThreshold: { mouse: 10, touch: 20 },
    focus: 0,
    gap: "1.25rem",
    padding: 0,
    pagination: true,
    omitEnd: true,
    arrows: false,
    drag: true,
    breakpoints: {
      990: {
        perPage: 1,
        perMove: 1,
        gap: "1.25rem",
        focus: 0,
        padding: { left: "7rem", right: "7rem" },
      },
      749: {
        perPage: 1,
        perMove: 1,
        gap: "1.25rem",
        focus: 0,
        padding: { left: "3rem", right: "3rem" },
      },
    },
  }).mount();
}

export function initHomeLineUpSplide() {
  document.querySelectorAll<HTMLElement>(SPLIDE_SELECTOR).forEach(mountLineUpSplide);
}
